import { useUserCapabilities } from "@faire/retailer-visitor-shared/hooks/user/useUserCapabilities";
import { useUserLocale } from "@faire/retailer-visitor-shared/hooks/user/useUserLocale";
import { useUserPersonalInfo } from "@faire/retailer-visitor-shared/hooks/user/useUserPersonalInfo";
import { useUserType } from "@faire/retailer-visitor-shared/hooks/user/useUserType";
import { useSettingAndAssignMigrateUserStore } from "@faire/retailer-visitor-shared/settings/useSettingMigrateUserStore";
import { IUserStore } from "@faire/retailer-visitor-shared/stores/domain/IUserStore";
import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";

export const useUserStoreV2 = (): Partial<IUserStore> => {
  const shouldUseHooksMigration = useSettingAndAssignMigrateUserStore();
// eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
  return shouldUseHooksMigration ? useUserStoreTreatment() : useUserStoreControl();
};

const useUserStoreTreatment = () => {
  const userType = useUserType();
  const userLocale = useUserLocale();
  const userCapabilities = useUserCapabilities();
  const userPersonalInfo = useUserPersonalInfo();

  return {
    ...userType,
    ...userLocale,
    ...userCapabilities,
    ...userPersonalInfo,
  };
};

const useUserStoreControl = () => {
  return useUserStore([
    "isBrandUser",
    "isAdminUser",
    "isImpersonating",
    "isEmployee",
    "hasFaireEmailAddress",
    "browserLevelLanguage",
    "userLocaleKey",
    "browserLevelLocaleKey",
    "browserLevelLocaleOverride",
  ]);
};
